import React, { Fragment } from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  titleContainer: {
    flexDirection: 'row'
  },
  reportTitle: {
    color: '#2A4494',
    fontSize: 20,
    textAlign: 'center',
    textTransform: 'uppercase',
    fontStyle: 'bold'
  }
});


const InvoiceTitle = ({ title }) => (
  <Fragment>
    <View style={styles.titleContainer}>
      <Text style={styles.reportTitle}>{title}</Text>
    </View>
  </Fragment>
);

export default InvoiceTitle